import { TRIGGER_ADD_MONEY_API, TRIGGER_ADD_MONEY_API_SUCCESS } from 'redux/actionTypes';

export function triggerAddMoneyApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_ADD_MONEY_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerAddMoneyApiCallSuccess(data) {
	return {
		type: TRIGGER_ADD_MONEY_API_SUCCESS,
		data,
	};
}
